// Prices page (owner 11-04): paging, selection and CSV helpers, kept pure so the
// page and its tests share one definition. The whole price list comes from one
// call (/v1/{pid}/lookup_master/get, unpaged); paging and search are client-side.

// Page-size choices. ALL (0) shows every matching row on one page.
export const ALL = 0;
export const PAGE_SIZES = [10, 25, 50, 100, ALL];

// Rows per page actually used: "All" is the whole list (at least 1 so the
// arithmetic never divides by zero).
export const effectiveLimit = (limit, total) => (limit === ALL ? Math.max(total, 1) : limit);

export const pageCount = (total, limit) => (total <= 0 ? 0 : Math.ceil(total / effectiveLimit(limit, total)));

// Keep the page inside 1..pageCount (a delete can empty the last page).
export const clampPage = (page, total, limit) => {
  const n = pageCount(total, limit);
  if (n === 0) return 1;
  return Math.min(Math.max(1, page), n);
};

export const pageSlice = (list, page, limit) => {
  const size = effectiveLimit(limit, list.length);
  const start = (page - 1) * size;
  return list.slice(start, start + size);
};

// 1-based page holding the row at index i.
export const pageOfIndex = (i, limit, total) => Math.floor(i / effectiveLimit(limit, total)) + 1;

export const matchesSearch = (item, search) =>
  (item?.content ?? "").toString().toLowerCase().includes((search || "").toLowerCase());

export const filterPrices = (list, search) => (Array.isArray(list) ? list.filter((it) => matchesSearch(it, search)) : []);

const money = (v) => {
  const n = parseFloat(v);
  return Number.isNaN(n) ? "0.00" : n.toFixed(2);
};

const csvCell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const pricesCsv = (rows) =>
  [["Type", "Content", "Insurance Cost", "Selfpay Cost"], ...rows.map((r) => [r.context, r.content, money(r.insurance_cost), money(r.selfpay_cost)])]
    .map((line) => line.map(csvCell).join(","))
    .join("\r\n");
